jQuery(document).ready(function ($) {
  var spflag = true;
  var animeSpd = 400;
  var menuHideHeight = 1000;
  var menuShowHeight = 1200;
  var scrollpos;
  
  
	function checkBreakPoint() {
		w = $(window).width();
		if (w <= 767) {
			$('#feel .giulia-nav-container .giulia-feel').not('.slick-initialized').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				prevArrow: '<div class="giulia-nav-feel-prev"><img src="image/icon-arrow-accordion-red.svg" alt=""></div>',
				nextArrow: '<div class="giulia-nav-feel-next"><img src="image/icon-arrow-accordion-red.svg" alt=""></div>',
			});
			$('#price .giulia-price').not('.slick-initialized').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				prevArrow: '<div class="giulia-nav-feel-prev"><img src="image/icon-arrow-accordion-red.svg" alt=""></div>',
				nextArrow: '<div class="giulia-nav-feel-next"><img src="image/icon-arrow-accordion-red.svg" alt=""></div>',
				dots: true,
				appendDots: '.giulia-price-dots',
			});
			
			$('#top-slider').not('.slick-initialized').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				prevArrow: '<div class="giulia-charm-slder-prev"><img src="image/icon-arrow-left-white.svg" alt=""></div>',
				nextArrow: '<div class="giulia-charm-slder-next"><img src="image/icon-arrow-right-white.svg" alt=""></div>',
				dots: true,
				appendDots: '.giulia-charm-slder-controller',
				appendArrows: '.giulia-charm-slder-controller',
			});

			
			
		} else {
			// PC向け
			$('#feel giulia-nav-container .giulia-feel.slick-initialized').slick('unslick');
			$('#price .giulia-price.slick-initialized').slick('unslick');
		}
	}
	// ウインドウがリサイズする度にチェック
	$(window).resize(function(){
		checkBreakPoint();
	});
	// 初回チェック
	checkBreakPoint();  
	
  
  
  
  //デザインで選ぶ
  $('.giulia-designs-trigger').on('click',function(){
	  $(this).toggleClass('active');
	  $(this).next('.giulia-designs-pannel').slideToggle();
  });
  
  //価格と経済性で選ぶ
  
  
  //STELVIOの魅力
  var option = {
      dots: false,
      speed: animeSpd,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
			prevArrow: '<div class="giulia-charm-prev"><img src="image/icon-arrow-left-white.svg" alt=""></div>',
			nextArrow: '<div class="giulia-charm-next"><img src="image/icon-arrow-right-white.svg" alt=""></div>',
	    responsive: [
		    {
			    breakpoint: 768,
			    settings: {
				    centerPadding:"10%",
				    centerMode:true,
			    }
		    }
	    ]
  }
  
  $('#js-giulia-charm-performance').slick(option);
  $('#js-giulia-charm-utility').slick(option);
  $('#js-giulia-charm-system').slick(option);
  
  $(window).on('load',function(){
	  $('.giulia-catch').clone().prependTo('body').addClass('is-hidden');
  });
	var startOffset = $('.giulia-alpha').offset().top;
	var endOffset = startOffset + $('.giulia-alpha').height();
  
  $(window).on('scroll',function(){
	  var elemOffset = $('.giulia-catch.is-hidden').offset().top;
	  if($(this).scrollTop() >= startOffset ){
		  $('.giulia-catch.is-hidden').addClass('is-show');
		  if(elemOffset > endOffset){
		  	$('.giulia-catch.is-hidden').hide();
		  }
	  }else if($(this).scrollTop() == 0){
		  $('.giulia-catch.is-hidden').removeClass('is-show').show();
	  }
  });


/*

	console.log("startOffset:"+startOffset);
	console.log("endOffset:"+endOffset);

*/

});
